// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XMainForm_XMainForm__ArCV0 {
  flex-shrink: 0;
  outline-width: 0px;
  outline-color: chartreuse;
  outline-style: none;
  display: flex;
  border: none;
  flex-direction: column;
  flex-grow: 1;
  min-width: 640px;
  max-width: 1024px;
  margin-left: auto;
  margin-right: auto;
  background-color: white;
}`, "",{"version":3,"sources":["webpack://./src/X/components/forms/XMainForm.module.scss","webpack://./src/X/styles/common.scss"],"names":[],"mappings":"AAIA;ECMI,cAAA;EAPA,kBAAA;EACA,yBAAA;EACA,mBAAA;EDEA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,YAAA;EAGA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;AAHJ","sourcesContent":["//@use 'sass:meta';\n@use \"../../styles/common\";\n@use \"../../styles/themes\";\n\n.XMainForm {\n    @include common.noshrink;\n    @include common.nodebug;\n    display: flex;\n    border: none;\n    flex-direction: column;\n    flex-grow: 1;\n    //width: auto;\n    //height: 100%;\n    min-width: 640px;\n    max-width: 1024px;\n    margin-left: auto;\n    margin-right: auto;\n    background-color: white;\n}\n","\n@mixin nodebug\n{\n    outline-width: 0px;\n    outline-color: chartreuse;\n    outline-style: none;\n}\n\n@mixin noshrink\n{\n    flex-shrink: 0;\n}\n\n@mixin noselect {\n    -webkit-touch-callout: none;\n\t-webkit-user-select: none;\n\t-khtml-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none;\n}\n\n@mixin nomouse {\n    pointer-events: none;\n}\n\n@mixin border-box {\n    -moz-box-sizing: border-box;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"XMainForm": `XMainForm_XMainForm__ArCV0`
};
export default ___CSS_LOADER_EXPORT___;
